import React from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  Button, 
  Label, 
  FormGroup, 
  Input, 
  Alert 
} from 'reactstrap';
import Datetime from "react-datetime";
import moment from 'moment';
// Components
import CurrencyInput from 'components/CurrencyInput/CurrencyInput';
// Helpers
import { formatPrice } from 'helpers/pricing';
// Requests
import { getPaymentsRequest } from 'api/payment'
// Contexts
import ProjectContext from 'contexts/ProjectContext';

class CancelReservationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      unit: {},
      refundReservationPayment: false, 
      refundDate: null,
      refundAmount: null,
      rentalAmount: null,
      reservationPayment: null
    };
    this.toggle = this.toggle.bind(this);
  }

  static contextType = ProjectContext;

  async toggle() {
    const { models = [], selectedModel, client} = this.props.selectedUnit
    let modelsIndex = models.findIndex(x => x.name === selectedModel.name)
    
    if(!this.state.modal) {
      await this.getUnitPayments();
    }
    
    this.setState((prevState) => ({
      modal: !prevState.modal,
      unit: {
        ...this.props.selectedUnit,
        client
      },
      modelsIndex
    }));

  }

  getUnitPayments = async () => {
    const { _id, client } = this.props.selectedUnit;

    const paymentsObj = await getPaymentsRequest({
      limit: 0, 
      page: 0, 
      client: client._id,
      unit: _id,
      type: "downPayment",
      subtype: "reservation"
    });

    this.setState({
      reservationPayment: paymentsObj.payments[0]
    })
  }

  onChangeCheckbox = (e) => {
		const { target } = e;
		const { name, checked } = target;

        this.setState({
            [name]: checked,
        });

	}

  onChangeField = (e) => {
		const { target } = e;
		let { name, value } = target;

        this.setState({
            [name]: value,
        })
	}

  render() {
    const { 
       backdrop = false,
       onSave,
       loading,
       error,
       cancelSale=false
    } = this.props;

    const {
      client,
    } = this.state.unit

    const {
      unit,
      refundReservationPayment,
      refundDate,
      refundAmount,
      reservationPayment
    } = this.state;

    const saveData = {
      unit,
      ...(cancelSale ? { refundSalePayment: refundReservationPayment } : {refundReservationPayment}),
      refundDate,
      refundAmount
    }

    return (
      <Modal backdrop={backdrop} className="cancel-reservation" isOpen={this.state.modal} toggle={this.toggle} style={{marginTop: '-120px'}}>
        <ModalHeader toggle={this.toggle}>{cancelSale ? 'Cancel Sale' : 'Cancel Reservation'}</ModalHeader>
        <ModalBody>
          <Container className="p-2">
            <Row>
              <Col>
                <FormGroup>
                    <Label>Selected Model</Label>
                    <Input
                      name="models"
                      type="text"
                      value={unit?.selectedModel?.name || "N/A"}
                      disabled
                    />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                    <Label>Price</Label>
                    <Input
                      name="models"
                      type="text"
                      value={formatPrice(unit?.selectedModel?.price ?? 0) || "N/A"}
                      disabled
                    />
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                    <Label>TCP</Label>
                    <Input
                      name="models"
                      type="text"
                      value={formatPrice(unit?.selectedModel?.tcp ?? 0) || "N/A"}
                      disabled
                    />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Client</Label>
                  <Input
                    name="client"
                    type="text"
                    value={client ? `${client.first_name} ${client.last_name}` : "N/A"}
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>
            {!cancelSale &&
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Reservation Payment</Label>
                    <Input
                      name="reservationPayment"
                      type="text"
                      value={reservationPayment ? formatPrice(reservationPayment.amount) : "N/A"}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
            }
            <FormGroup>
              <div className="form-check">
                <label className="form-check-label">
                  <input className="form-check-input" onChange={this.onChangeCheckbox} name="refundReservationPayment" type="checkbox" checked={!!refundReservationPayment} />
                  {cancelSale ? 'Generate Refund Payment' : 'Refund Reservation Payment'}
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
            </FormGroup>
            {refundReservationPayment && 
              <>
                <FormGroup>
                  <Label>Refund Amount <span className="required-start">*</span></Label>
                  <CurrencyInput 
                    name="refundAmount"
                    price={refundAmount || 0}
                    onChange={(value) => this.onChangeField({ target: { name: "refundAmount", value } })}
                    placeholder="Refund Amount"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Refund Date <span className="required-start">*</span></Label>
                  <Datetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date of refund payment",
                      name: "refundDate"
                    }}
                    dateFormat="MM/DD/YYYY"
                    timeFormat={false}
                    value={typeof refundDate === 'string' ? moment(refundDate).format("MM/DD/YYYY") : refundDate}
                    onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "refundDate" }})}
                    closeOnSelect={true}
                  />
                </FormGroup>
              </>
            }
            {error && 
              <Alert color="danger">
                {error.message}
              </Alert>
            }
          </Container>
        </ModalBody>
        <ModalFooter className="justify-content-end">
						<Button 
							color="primary" 
							className="btn-success-override mr-2" 
							onClick={() => onSave(saveData)}
							disabled={loading}
						>
							{loading ? "Saving" : "Save"}
						</Button>
						<Button color="secondary" className="btn-danger-override" onClick={this.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CancelReservationModal;